"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var querystring_1 = __importDefault(require("querystring"));
var Sentry = __importStar(require("@sentry/react"));
var constants_1 = require("../../../shared/constants");
var types_1 = require("./types");
var requests_1 = require("../../app/util/requests");
var actions_1 = __importDefault(require("../../app/components/pages/RootPage/actions"));
var url_1 = require("../../app/util/url");
var validation_1 = require("../../../shared/util/validation");
var types_2 = require("../../app/util/types");
var types_3 = require("../reducers/types");
var messages_1 = require("../../../shared/util/messages");
var ga_1 = require("../../app/util/ga");
var jobs_1 = require("../../../shared/util/jobs");
var urlQueryHelper_1 = __importDefault(require("../../app/helpers/urlQueryHelper"));
var setUrlUploadState = function (payload) { return ({
    type: types_1.UserAction.SET_URL_UPLOAD_STATE,
    payload: payload,
}); };
var setFileUploadState = function (payload) { return ({
    type: types_1.UserAction.SET_FILE_UPLOAD_STATE,
    payload: payload,
}); };
var isFetchingUrls = function (payload) { return ({
    type: types_1.UserAction.IS_FETCHING_URLS,
    payload: payload,
}); };
var setLastCreatedLink = function (payload) { return ({
    type: types_1.UserAction.SET_LAST_CREATED_LINK,
    payload: payload,
}); };
var setIsUploading = function (payload) { return ({
    type: types_1.UserAction.SET_IS_UPLOADING,
    payload: payload,
}); };
var setEditedContactEmail = function (shortUrl, editedContactEmail) { return ({
    type: types_1.UserAction.SET_EDITED_CONTACT_EMAIL,
    payload: {
        shortUrl: shortUrl,
        editedContactEmail: editedContactEmail,
    },
}); };
var setEditedDescription = function (shortUrl, editedDescription) { return ({
    type: types_1.UserAction.SET_EDITED_DESCRIPTION,
    payload: {
        shortUrl: shortUrl,
        editedDescription: editedDescription,
    },
}); };
var setCreateShortLinkError = function (payload) { return ({
    type: types_1.UserAction.SET_CREATE_SHORT_LINK_ERROR,
    payload: payload,
}); };
var setUploadFileError = function (payload) { return ({
    type: types_1.UserAction.SET_UPLOAD_FILE_ERROR,
    payload: payload,
}); };
var isGetUrlsForUserSuccess = function (urls) { return ({
    type: types_1.UserAction.GET_URLS_FOR_USER_SUCCESS,
    payload: urls,
}); };
/**
 * Action to update multiple URL table properties.
 * @param {Array[key: string, value: string]} payload Array of array elements representing
 * key-value pairs for the tableConfig.
 * @example [ ['orderBy', 'shortUrl'], ['sortDirection', 'desc'] ]
 */
var setUrlTableConfig = function (payload) { return ({
    type: types_1.UserAction.SET_URL_TABLE_CONFIG,
    payload: payload,
}); };
var setUrlFilter = function (payload) { return ({
    type: types_1.UserAction.SET_URL_FILTER,
    payload: payload,
}); };
var updateUrlCount = function (urlCount) { return ({
    type: types_1.UserAction.UPDATE_URL_COUNT,
    payload: urlCount,
}); };
var setUserMessage = function (payload) { return ({ type: types_1.UserAction.SET_USER_MESSAGE, payload: payload }); };
var setUserAnnouncement = function (payload) { return ({
    type: types_1.UserAction.SET_USER_ANNOUNCEMENT,
    payload: payload,
}); };
var getUserMessage = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, text;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, requests_1.get)('/api/user/message')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.text()];
                case 2:
                    text = _a.sent();
                    if (text)
                        dispatch(setUserMessage(text));
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
var getUserAnnouncement = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, requests_1.get)('/api/user/announcement')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    payload = _a.sent();
                    if (payload)
                        dispatch(setUserAnnouncement(payload));
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
function handleError(dispatch, response) {
    return __awaiter(this, void 0, void 0, function () {
        var responseType, message, type, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    responseType = response.headers.get('content-type');
                    if (!(responseType === null || responseType === void 0 ? void 0 : responseType.includes('json'))) return [3 /*break*/, 2];
                    return [4 /*yield*/, response.json()];
                case 1:
                    json = _a.sent();
                    type = json.type;
                    message = json.message;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, response.text()];
                case 3:
                    message = _a.sent();
                    _a.label = 4;
                case 4:
                    message = message.replace('Error validating request body. ', '');
                    switch (type) {
                        case messages_1.MessageType.FileUploadError:
                            dispatch(setUploadFileError(message));
                            break;
                        case messages_1.MessageType.ShortUrlError:
                            dispatch(setCreateShortLinkError(message));
                            break;
                        default:
                            dispatch(actions_1.default.setErrorMessage(message));
                            break;
                    }
                    return [2 /*return*/];
            }
        });
    });
}
var closeStatusBar = function () { return ({
    type: types_1.UserAction.CLOSE_STATUS_BAR,
}); };
var setStatusBarErrorMessage = function (header, body, callbacks) { return ({
    type: types_1.UserAction.SET_STATUS_BAR_ERROR_MESSAGE,
    payload: { header: header, body: body, callbacks: callbacks },
}); };
var setStatusBarInfoMessage = function (header, body) { return ({
    type: types_1.UserAction.SET_STATUS_BAR_INFO_MESSAGE,
    payload: { header: header, body: body },
}); };
var setStatusBarSuccessMessage = function (header, body, callbacks) { return ({
    type: types_1.UserAction.SET_STATUS_BAR_SUCCESS_MESSAGE,
    payload: { header: header, body: body, callbacks: callbacks },
}); };
// retrieve linkHistory based on query object
var getLinkHistory = function (queryObj) { return __awaiter(void 0, void 0, void 0, function () {
    var query, response, isOk, json;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = querystring_1.default.stringify(queryObj);
                return [4 /*yield*/, (0, requests_1.get)("/api/link-audit?".concat(query))];
            case 1:
                response = _a.sent();
                isOk = response.ok;
                return [4 /*yield*/, response.json()];
            case 2:
                json = _a.sent();
                return [2 /*return*/, { json: json, isOk: isOk }];
        }
    });
}); };
var isGetLinkHistoryForUserSuccess = function (linkHistory, totalCount) { return ({
    type: types_1.UserAction.GET_LINK_HISTORY_FOR_USER_SUCCESS,
    payload: {
        linkHistory: linkHistory,
        totalCount: totalCount,
    },
}); };
var resetLinkHistory = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(isGetLinkHistoryForUserSuccess([], 0));
            return [2 /*return*/];
        });
    }); };
};
// retrieves urls based on url table config
var getLinkHistoryForUser = function (shortUrl, offset, limit) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var queryObj, _a, json, isOk, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    queryObj = {
                        limit: limit,
                        url: shortUrl,
                        offset: offset,
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getLinkHistory(queryObj)];
                case 2:
                    _a = _b.sent(), json = _a.json, isOk = _a.isOk;
                    if (!isOk) {
                        throw new Error(json.message || 'Error fetching link history');
                    }
                    dispatch(isGetLinkHistoryForUserSuccess(json.changes, json.totalCount));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    dispatch(actions_1.default.setErrorMessage(String(error_1)));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
// retrieve urls based on query object
var getUrls = function (queryObj) { return __awaiter(void 0, void 0, void 0, function () {
    var query, response, isOk, json;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = querystring_1.default.stringify(queryObj);
                return [4 /*yield*/, (0, requests_1.get)("/api/user/url?".concat(query))];
            case 1:
                response = _a.sent();
                isOk = response.ok;
                return [4 /*yield*/, response.json()];
            case 2:
                json = _a.sent();
                return [2 /*return*/, { json: json, isOk: isOk }];
        }
    });
}); };
// retrieves urls based on url table config, with search by either link or tags
var getUrlsForUser = function () {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, tableConfig, queryObj, _a, json, isOk, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = getState();
                    tableConfig = state.user.tableConfig;
                    queryObj = (0, urlQueryHelper_1.default)(tableConfig);
                    dispatch(isFetchingUrls(true));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getUrls(queryObj)];
                case 2:
                    _a = _b.sent(), json = _a.json, isOk = _a.isOk;
                    if (!isOk) {
                        throw new Error(json.message || 'Error fetching URLs');
                    }
                    json.urls.forEach(function (url) {
                        /* eslint-disable no-param-reassign */
                        url.createdAt = (0, moment_timezone_1.default)(url.createdAt)
                            .tz('Singapore')
                            .format('D MMM YYYY');
                        url.editedLongUrl = (0, url_1.removeHttpsProtocol)(url.longUrl);
                        url.editedContactEmail = url.contactEmail;
                        url.editedDescription = url.description;
                        /* eslint-enable no-param-reassign */
                    });
                    dispatch(isGetUrlsForUserSuccess(json.urls));
                    dispatch(updateUrlCount(json.count));
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _b.sent();
                    dispatch(actions_1.default.setErrorMessage(String(error_2)));
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(isFetchingUrls(false));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
var resetUserState = function () { return ({
    type: types_1.UserAction.RESET_USER_STATE,
}); };
var wipeUserState = function () { return ({
    type: types_1.UserAction.WIPE_USER_STATE,
}); };
// API call to update long URL
var updateLongUrl = function (shortUrl, longUrl) {
    return function (dispatch) {
        // Append https:// as the protocol is stripped out
        // TODO: consider using Upgrade-Insecure-Requests header for HTTP
        if (!/^(http|https):\/\//.test(longUrl)) {
            longUrl = "https://".concat(longUrl); // eslint-disable-line no-param-reassign
        }
        if (!(0, validation_1.isValidUrl)(longUrl)) {
            dispatch(actions_1.default.setErrorMessage('URL is invalid.'));
            return null;
        }
        return (0, requests_1.patch)('/api/user/url', { longUrl: longUrl, shortUrl: shortUrl }).then(function (response) {
            if (response.ok) {
                dispatch(getUrlsForUser());
                dispatch(actions_1.default.setSuccessMessage('URL is updated.'));
                return null;
            }
            return response.json().then(function (json) {
                dispatch(actions_1.default.setErrorMessage(json.message));
                return null;
            });
        });
    };
};
// API call to update description and contact email
var updateUrlInformation = function (shortUrl) {
    return function (dispatch, getState) {
        var user = getState().user;
        var url = user.urls.filter(function (urlToCheck) { return urlToCheck.shortUrl === shortUrl; })[0];
        if (!url) {
            dispatch(actions_1.default.setErrorMessage('Url not found.'));
            return null;
        }
        return (0, requests_1.patch)('/api/user/url', {
            contactEmail: url.editedContactEmail ? url.editedContactEmail : null,
            description: url.editedDescription,
            shortUrl: shortUrl,
        }).then(function (response) {
            if (response.ok) {
                dispatch(getUrlsForUser());
                dispatch(actions_1.default.setSuccessMessage('URL is updated.'));
                return null;
            }
            return response.json().then(function (json) {
                dispatch(actions_1.default.setErrorMessage(json.message));
                return null;
            });
        });
    };
};
// API call to replace file
var replaceFile = function (shortUrl, file, onError) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setIsUploading(true));
                    data = new FormData();
                    data.append('file', file, file.name);
                    data.append('shortUrl', shortUrl);
                    return [4 /*yield*/, (0, requests_1.patchFormData)('/api/user/url', data)];
                case 1:
                    response = _a.sent();
                    dispatch(setIsUploading(false));
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    onError(json.message);
                    return [2 /*return*/];
                case 3:
                    dispatch(getUrlsForUser());
                    dispatch(actions_1.default.setSuccessMessage('Your link has been updated.'));
                    return [2 /*return*/];
            }
        });
    }); };
};
// For setting short link value in the input box
var setShortUrl = function (shortUrl) { return ({
    type: types_1.UserAction.SET_SHORT_URL,
    payload: shortUrl,
}); };
// For setting URL value in the input box
var setLongUrl = function (longUrl) { return ({
    type: types_1.UserAction.SET_LONG_URL,
    payload: (0, url_1.removeHttpsProtocol)(longUrl),
}); };
var setEditedLongUrl = function (shortUrl, editedLongUrl) { return ({
    type: types_1.UserAction.SET_EDITED_LONG_URL,
    payload: { shortUrl: shortUrl, editedLongUrl: editedLongUrl },
}); };
// For generating a random short URL
var setRandomShortUrl = function () { return function (dispatch) {
    return (0, url_1.generateShortUrl)().then(function (randomUrl) {
        dispatch({
            type: types_1.UserAction.SET_RANDOM_SHORT_URL,
            payload: randomUrl,
        });
    });
}; };
var isToggleUrlStateSuccess = function (payload) { return ({
    type: types_1.UserAction.TOGGLE_URL_STATE_SUCCESS,
    payload: payload,
}); };
// Toggle URL between active / inactive
var toggleUrlState = function (shortUrl, state) {
    return function (dispatch) {
        var toState = state === types_3.UrlState.Active ? types_3.UrlState.Inactive : types_3.UrlState.Active;
        (0, requests_1.patch)('/api/user/url', { shortUrl: shortUrl, state: toState }).then(function (response) {
            if (response.ok) {
                dispatch(isToggleUrlStateSuccess({ shortUrl: shortUrl, toState: toState }));
                return null;
            }
            return response.json().then(function (json) {
                dispatch(actions_1.default.setErrorMessage(json.message));
                return null;
            });
        });
    };
};
var openCreateUrlModal = function () { return ({
    type: types_1.UserAction.OPEN_CREATE_URL_MODAL,
}); };
var closeCreateUrlModal = function () { return ({
    type: types_1.UserAction.CLOSE_CREATE_URL_MODAL,
}); };
var urlCreated = function (dispatch, shortUrl) {
    dispatch(getUrlsForUser());
    dispatch(resetUserState());
    var successMessage = 'Your link has been created';
    dispatch(setLastCreatedLink(shortUrl));
    dispatch(actions_1.default.setSuccessMessage(successMessage));
};
/**
 * API call to create URL
 * If user is not logged in, the createUrl call returns unauthorized,
 * get them to login, else create the url.
 * @param history
 * @param tags
 * @returns Promise<bool> Whether creation succeeded.
 */
var createUrlOrRedirect = function (history) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var user, shortUrl, tags, longUrl, response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    user = getState().user;
                    shortUrl = user.shortUrl, tags = user.tags;
                    longUrl = user.longUrl;
                    // Test for malformed short URL
                    if (!/^[a-z0-9-]/.test(shortUrl)) {
                        // Sentry analytics: create link with url fail
                        Sentry.captureMessage('create link with url unsuccessful');
                        (0, ga_1.GAEvent)('modal page', 'create link from url', 'unsuccessful');
                        dispatch(actions_1.default.setErrorMessage('Short links should only consist of a-z, 0-9 and hyphens.'));
                        dispatch(setUrlUploadState(false));
                        return [2 /*return*/];
                    }
                    // Append https:// as the protocol is stripped out
                    // TODO: consider using Upgrade-Insecure-Requests header for HTTP
                    if (!/^(http|https):\/\//.test(longUrl)) {
                        longUrl = "https://".concat(longUrl); // eslint-disable-line no-param-reassign
                    }
                    if (!(0, validation_1.isValidUrl)(longUrl)) {
                        // Sentry analytics: create link with url fail
                        Sentry.captureMessage('create link with url unsuccessful');
                        (0, ga_1.GAEvent)('modal page', 'create link from url', 'unsuccessful');
                        dispatch(actions_1.default.setErrorMessage('URL is invalid.'));
                        dispatch(setUrlUploadState(false));
                        return [2 /*return*/];
                    }
                    if (!(0, validation_1.isValidTags)(tags)) {
                        // Sentry analytics: create link with url fail
                        Sentry.captureMessage('create link with url unsuccessful');
                        (0, ga_1.GAEvent)('modal page', 'create link from url', 'unsuccessful');
                        dispatch(actions_1.default.setErrorMessage('Tags are invalid.'));
                        dispatch(setUrlUploadState(false));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0, requests_1.postJson)('/api/user/url', {
                            longUrl: longUrl,
                            shortUrl: shortUrl,
                            tags: tags,
                        })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 2];
                    // Sentry analytics: create link with url fail
                    Sentry.captureMessage('create link with url unsuccessful');
                    (0, ga_1.GAEvent)('modal page', 'create link from url', 'unsuccessful');
                    if (response.status === 401) {
                        history.push(types_2.LOGIN_PAGE);
                        dispatch(setUrlUploadState(false));
                    }
                    else {
                        handleError(dispatch, response);
                        dispatch(setUrlUploadState(false));
                    }
                    return [3 /*break*/, 4];
                case 2:
                    (0, ga_1.GAEvent)('modal page', 'create link from url', 'successful');
                    return [4 /*yield*/, response.json()];
                case 3:
                    json = _a.sent();
                    urlCreated(dispatch, json.shortUrl);
                    dispatch(setUrlUploadState(true));
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var transferOwnership = function (shortUrl, newOwner, onSuccess) {
    return function (dispatch) {
        return (0, requests_1.patch)('/api/user/url/ownership', { shortUrl: shortUrl, newUserEmail: newOwner }).then(function (response) {
            if (response.ok) {
                // Google Analytics: Transfer ownership - success and shorturl are combined together to create unique actions
                (0, ga_1.GAEvent)('transfer link ownership', 'successful', "/".concat(shortUrl.toString()));
                onSuccess();
                dispatch(getUrlsForUser());
                var successMessage = "Your link /".concat(shortUrl, " has been transferred to ").concat(newOwner);
                dispatch(actions_1.default.setSuccessMessage(successMessage));
            }
            else {
                // Sentry analytics: transfer ownership fail
                Sentry.captureMessage('transfer ownership unsuccessful');
                (0, ga_1.GAEvent)('transfer link ownership', 'unsuccessful', "/".concat(shortUrl.toString()));
                // Otherwise, show error toast with relevant error message.
                response.json().then(function (json) {
                    dispatch(actions_1.default.setErrorMessage(json.message));
                });
            }
        });
    };
};
/**
 * API call to upload a file.
 * @param file
 * @returns Promise<bool> Whether file upload succeeded.
 */
var uploadFile = function (file) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, shortUrl, tags, data, response, json;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getState().user, shortUrl = _a.shortUrl, tags = _a.tags;
                    if (file === null) {
                        // Sentry analytics: create link with file fail
                        Sentry.captureMessage('create link with file unsuccessful');
                        (0, ga_1.GAEvent)('modal page', 'create link from file', 'unsuccessful');
                        dispatch(actions_1.default.setErrorMessage('File is missing.'));
                        dispatch(setFileUploadState(false));
                        return [2 /*return*/];
                    }
                    if (!/^[a-z0-9-]/.test(shortUrl)) {
                        // Sentry analytics: create link with url fail
                        Sentry.captureMessage('create link with file unsuccessful');
                        (0, ga_1.GAEvent)('modal page', 'create link from file', 'unsuccessful');
                        dispatch(actions_1.default.setErrorMessage('Short links should only consist of a-z, 0-9 and hyphens.'));
                        dispatch(setFileUploadState(false));
                        return [2 /*return*/];
                    }
                    if (!(0, validation_1.isValidTags)(tags)) {
                        // Sentry analytics: create link with url fail
                        Sentry.captureMessage('create link with file unsuccessful');
                        (0, ga_1.GAEvent)('modal page', 'create link from file', 'unsuccessful');
                        dispatch(actions_1.default.setErrorMessage('Tags are invalid.'));
                        dispatch(setFileUploadState(false));
                        return [2 /*return*/];
                    }
                    dispatch(setIsUploading(true));
                    data = new FormData();
                    data.append('file', file, file.name);
                    data.append('shortUrl', shortUrl);
                    if (tags) {
                        // Serialize the tags in JSON format as a string
                        data.append('tags', JSON.stringify(tags));
                    }
                    return [4 /*yield*/, (0, requests_1.postFormData)('/api/user/url', data)];
                case 1:
                    response = _b.sent();
                    dispatch(setIsUploading(false));
                    if (!!response.ok) return [3 /*break*/, 3];
                    // Sentry analytics: create link with file fail
                    Sentry.captureMessage('create link with file unsuccessful');
                    (0, ga_1.GAEvent)('modal page', 'create link from file', 'unsuccessful');
                    return [4 /*yield*/, handleError(dispatch, response)];
                case 2:
                    _b.sent();
                    dispatch(setFileUploadState(false));
                    return [3 /*break*/, 5];
                case 3:
                    (0, ga_1.GAEvent)('modal page', 'create link from file', 'successful');
                    return [4 /*yield*/, response.json()];
                case 4:
                    json = _b.sent();
                    urlCreated(dispatch, json.shortUrl);
                    dispatch(setFileUploadState(true));
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
// For setting tags value in the tags autocomplete input box
var setTags = function (tags) { return ({
    type: types_1.UserAction.SET_TAGS,
    payload: tags,
}); };
// API call to update tags
var updateTags = function (shortUrl, tags) {
    return function (dispatch) {
        if (!(0, validation_1.isValidTags)(tags)) {
            dispatch(actions_1.default.setErrorMessage('Tags are invalid.'));
            return null;
        }
        return (0, requests_1.patch)('/api/user/url', { shortUrl: shortUrl, tags: tags }).then(function (response) {
            if (response.ok) {
                dispatch(getUrlsForUser());
                dispatch(actions_1.default.setSuccessMessage('Tags are updated.'));
                return null;
            }
            return response.json().then(function (json) {
                dispatch(actions_1.default.setErrorMessage(json.message));
                return null;
            });
        });
    };
};
var setQRCodeGenerationMessage = function (status, callbacks) {
    return function (dispatch) {
        if (status === jobs_1.JobStatusEnum.Success) {
            var header = "QR codes successfully generated";
            var body = "Please download your QR codes here or via email";
            dispatch(setStatusBarSuccessMessage(header, body, callbacks));
        }
        if (status === jobs_1.JobStatusEnum.InProgress) {
            var header = "QR codes generation in progress";
            var body = "Please wait to download your QR codes";
            dispatch(setStatusBarInfoMessage(header, body));
        }
        if (status === jobs_1.JobStatusEnum.Failure) {
            var header = "QR codes failed to generate";
            var body = "Please try again";
            dispatch(setStatusBarErrorMessage(header, body, callbacks));
        }
    };
};
var getJobInformationForPendingJobId = function (jobId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var query, response, isOk, resp, job, jobItemUrls, status_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    query = querystring_1.default.stringify({ jobId: jobId });
                    return [4 /*yield*/, (0, requests_1.get)("/api/user/job/status?".concat(query))];
                case 1:
                    response = _a.sent();
                    isOk = response.ok;
                    if (!!isOk) return [3 /*break*/, 2];
                    // retry
                    dispatch(getJobInformationForPendingJobId(jobId));
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, response.json()];
                case 3:
                    resp = _a.sent();
                    job = resp.job, jobItemUrls = resp.jobItemUrls;
                    status_1 = job.status;
                    dispatch(setQRCodeGenerationMessage(status_1, jobItemUrls));
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var getLatestJob = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, isOk, resp, job, jobItemUrls, status, id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, requests_1.get)("/api/user/job/latest")];
                case 1:
                    response = _a.sent();
                    isOk = response.ok;
                    return [4 /*yield*/, response.json()];
                case 2:
                    resp = _a.sent();
                    if (!isOk) {
                        throw new Error(resp.message || 'Error fetching user jobs ');
                    }
                    job = resp.job, jobItemUrls = resp.jobItemUrls;
                    if (!job || !jobItemUrls)
                        return [2 /*return*/];
                    status = job.status, id = job.id;
                    if (status === 'IN_PROGRESS') {
                        dispatch(getJobInformationForPendingJobId(id));
                    }
                    dispatch(setQRCodeGenerationMessage(status, jobItemUrls));
                    return [2 /*return*/];
            }
        });
    }); };
};
/**
 * API call to upload file for bulk creation.
 * @param file
 * @returns Promise<bool> Whether bulk creation succeeded.
 */
var bulkCreateUrl = function (file) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var tags, fileName, data, response, _a, count, job;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    tags = getState().user.tags;
                    if (file === null) {
                        // Sentry analytics: bulk create link with file fail
                        Sentry.captureMessage('bulk create upload missing file');
                        (0, ga_1.GAEvent)('modal page', 'bulk create upload', 'unsuccessful');
                        dispatch(actions_1.default.setErrorMessage('File is missing.'));
                        dispatch(setFileUploadState(false));
                        return [2 /*return*/];
                    }
                    if (file) {
                        fileName = file.name;
                        if (!fileName.includes('.') || !fileName.split('.').pop()) {
                            dispatch(actions_1.default.setErrorMessage('File is invalid.'));
                            dispatch(setFileUploadState(false));
                            Sentry.captureMessage('bulk create upload invalid file');
                            (0, ga_1.GAEvent)('modal page', 'bulk create upload', 'unsuccessful');
                            return [2 /*return*/];
                        }
                        if (fileName.split('.').pop() !== 'csv') {
                            dispatch(actions_1.default.setErrorMessage('Only csv files are allowed.'));
                            dispatch(setFileUploadState(false));
                            Sentry.captureMessage('bulk create upload invalid file');
                            (0, ga_1.GAEvent)('modal page', 'bulk create upload', 'unsuccessful');
                            return [2 /*return*/];
                        }
                        if (file.size > constants_1.MAX_CSV_UPLOAD_SIZE) {
                            dispatch(actions_1.default.setErrorMessage('Bulk csv file exceeds the size limit'));
                            dispatch(setFileUploadState(false));
                            Sentry.captureMessage('bulk create upload invalid file');
                            (0, ga_1.GAEvent)('modal page', 'bulk create upload', 'unsuccessful');
                            return [2 /*return*/];
                        }
                    }
                    if (!(0, validation_1.isValidTags)(tags)) {
                        Sentry.captureMessage('bulk create upload invalid tags');
                        (0, ga_1.GAEvent)('modal page', 'bulk create upload', 'unsuccessful');
                        dispatch(actions_1.default.setErrorMessage('Tags are invalid.'));
                        dispatch(setFileUploadState(false));
                        return [2 /*return*/];
                    }
                    dispatch(setIsUploading(true));
                    data = new FormData();
                    data.append('file', file, file.name);
                    data.append('tags', JSON.stringify(tags));
                    return [4 /*yield*/, (0, requests_1.postFormData)('/api/user/url/bulk', data)];
                case 1:
                    response = _b.sent();
                    dispatch(setIsUploading(false));
                    if (!!response.ok) return [3 /*break*/, 3];
                    Sentry.captureMessage('bulk creation invalid');
                    (0, ga_1.GAEvent)('modal page', 'bulk creation', 'unsuccessful');
                    return [4 /*yield*/, handleError(dispatch, response)];
                case 2:
                    _b.sent();
                    dispatch(setFileUploadState(false));
                    return [3 /*break*/, 5];
                case 3:
                    Sentry.captureMessage('bulk creation success');
                    (0, ga_1.GAEvent)('modal page', 'bulk creation', 'successful');
                    dispatch(getUrlsForUser());
                    dispatch(resetUserState());
                    return [4 /*yield*/, response.json()];
                case 4:
                    _a = _b.sent(), count = _a.count, job = _a.job;
                    dispatch(actions_1.default.setSuccessMessage("".concat(count, " links have been created")));
                    if (job)
                        dispatch(getLatestJob());
                    dispatch(setFileUploadState(true));
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
exports.default = {
    closeStatusBar: closeStatusBar,
    setStatusBarErrorMessage: setStatusBarErrorMessage,
    setStatusBarInfoMessage: setStatusBarInfoMessage,
    setStatusBarSuccessMessage: setStatusBarSuccessMessage,
    getUrlsForUser: getUrlsForUser,
    getLinkHistoryForUser: getLinkHistoryForUser,
    resetLinkHistory: resetLinkHistory,
    isFetchingUrls: isFetchingUrls,
    createUrlOrRedirect: createUrlOrRedirect,
    setShortUrl: setShortUrl,
    setLongUrl: setLongUrl,
    setEditedLongUrl: setEditedLongUrl,
    setRandomShortUrl: setRandomShortUrl,
    toggleUrlState: toggleUrlState,
    openCreateUrlModal: openCreateUrlModal,
    closeCreateUrlModal: closeCreateUrlModal,
    transferOwnership: transferOwnership,
    wipeUserState: wipeUserState,
    resetUserState: resetUserState,
    updateLongUrl: updateLongUrl,
    updateUrlCount: updateUrlCount,
    uploadFile: uploadFile,
    bulkCreateUrl: bulkCreateUrl,
    setUrlTableConfig: setUrlTableConfig,
    getUrls: getUrls,
    setUploadFileError: setUploadFileError,
    setCreateShortLinkError: setCreateShortLinkError,
    setUrlFilter: setUrlFilter,
    replaceFile: replaceFile,
    setEditedContactEmail: setEditedContactEmail,
    setEditedDescription: setEditedDescription,
    getUserMessage: getUserMessage,
    getUserAnnouncement: getUserAnnouncement,
    updateUrlInformation: updateUrlInformation,
    setFileUploadState: setFileUploadState,
    setUrlUploadState: setUrlUploadState,
    setTags: setTags,
    updateTags: updateTags,
    getLatestJob: getLatestJob,
};
